import Cookies from 'js-cookie';

export const cookieUtils = {
  setStudentData: (studentData) => {
    Cookies.set('studentData', JSON.stringify(studentData), { expires: 7 });
  },
  
  // Lightweight progress persistence for refresh/revisit behavior
  setProgress: (progress) => {
    try {
      localStorage.setItem('quiz_progress', JSON.stringify(progress));
    } catch (_) {}
  },
  getProgress: () => {
    try {
      const data = localStorage.getItem('quiz_progress');
      return data ? JSON.parse(data) : null;
    } catch (_) { return null; }
  },
  clearProgress: () => {
    try { localStorage.removeItem('quiz_progress'); } catch (_) {}
  },
  
  getStudentData: () => {
    const data = Cookies.get('studentData');
    return data ? JSON.parse(data) : null;
  },
  
  clearStudentData: () => {
    Cookies.remove('studentData');
  },
  
  setAdminAuth: () => {
    Cookies.set('adminAuth', 'true', { expires: 1 });
  },
  
  getAdminAuth: () => {
    return Cookies.get('adminAuth') === 'true';
  },
  
  clearAdminAuth: () => {
    Cookies.remove('adminAuth');
  }
};
